
import React, { useState, useEffect } from 'react';
import { useHistory, Link } from 'react-router-dom';
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
    IconButton, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle
} from '@mui/material';
import { Delete as DeleteIcon, Edit as EditIcon, CheckCircle as ActivateIcon, Search as SearchIcon, Info as Info } from '@mui/icons-material';
import * as XLSX from 'xlsx';
import { fetchData, deleteData, activateData, postData } from '../../../apiService'; // Ensure postData is defined
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import CircularProgress from '@mui/material/CircularProgress';
import RefreshIcon from '@mui/icons-material/Refresh';
import AddIcon from '@mui/icons-material/Add';
import ApiIcon from '@mui/icons-material/Api';
import { Tooltip } from '@mui/material';

function PurchaseIndex() {
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const history = useHistory();
    const { isAuthenticated, companyId, permissions, token, logout, userId } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Transaction');
    const hasEditMasterPermission = permissions.includes('Edit Transaction');
    const hasDeleteMasterPermission = permissions.includes('Delete Transaction');
    const [isLoading, setIsLoading] = useState(false);
    const [importDialogOpen, setImportDialogOpen] = useState(false);
    const [fileData, setFileData] = useState([]);
    const [isFocused, setIsFocused] = useState(false);
    const branchId = 0;
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
    }, [isAuthenticated, companyId, branchId, token, logout]);

    const fetchtableData = async () => {

        setData([]);
        try {
            const response = await fetchData('PurchaseApi', `/PurchaseDetails/${companyId}/${fromDate}/${toDate}`, token);
            if (response.responseCode === '1111') {
                setData(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Customer Details:', error);
            if (error.response && error.response.status === 401) {
                logout();
                history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
            }
        }
    };

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const handleDelete = async () => {
        deleteData('PurchaseApi', `${deleteItemId}`, token)
            .then((response) => {
                fetchtableData();
                setDeleteItemId(null);
                setConfirmDialogOpen(false);
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };

    const handleActivate = (itemId) => {
        activateData('PurchaseApi', `${itemId}`, token)
            .then(() => {
                fetchtableData();
            })
            .catch((error) => {
                console.error('Error activating record:', error);
            });
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };



    function formatDate(dateString) {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        const formattedDate = new Date(dateString).toLocaleDateString('en-GB', options);
        return formattedDate;
    }

    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        setFromDate(selectedDate);
    };

    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        setToDate(selectedDate);
    };

    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    const getFormattedStartDate = () => {
        const monthStartDate = new Date();
        monthStartDate.setDate(1);
        return monthStartDate.toISOString().split('T')[0];
    };


    return (
        <div className="w-full  mx-auto" style={{ width: '95%', marginTop: '10px' }}>

            <div className='w-full mb-2 flex'>
                <h6 className='block uppercase tracking-wide text-black productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>Purchase </h6>
                <div style={{ marginLeft: '-30px', marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
                    <SearchIcon onClick={toggleSearchInput} style={{ cursor: 'pointer' }} />
                    {showSearchInput && (
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            type="text"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                            style={{ marginLeft: '10px', width: '250px' }}
                        />
                    )}
                </div>
                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                        From
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={fromDate} onChange={handleFromDateChange}
                        style={{ marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>
                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                        To
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={toDate} onChange={handleToDateChange}
                        style={{ marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>
                
                <Tooltip title="Data Loading">
                    <Button
                        // style={{ color: "black", height: '36px', marginLeft: '10px', marginTop: '20px' }}
                        onClick={fetchtableData}
                        className="linkcolor"
                        style={{
                            background: 'linear-gradient(to right,rgb(49, 106, 205),rgb(49, 106, 205))',
                            color: 'white',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '30px',
                            marginLeft: '15px',
                            marginTop: '1.50%',
                            textTransform: 'uppercase'

                        }}
                    >
                        Refresh
                    </Button>
                </Tooltip>


                <div style={{ display: 'flex', alignItems: 'center', marginTop: '15px' }}>
                    <Tooltip title="Create Purchase">

                        <Button

                            component={Link}
                            to="/PurchaseCreate"
                            className="linkcolor"
                            //style={{ marginLeft: '8px', color: 'orangered', fontWeight: 'bolder' }}
                            style={{
                                background: 'linear-gradient(to right,rgb(24, 149, 154),rgb(24, 149, 154))',
                                color: 'white',
                                textTransform: 'none',
                                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                maxHeight: '30px',
                                marginLeft: '15px',
                                marginTop: '1.25%',
                                textTransform: 'uppercase'

                            }}
                        >
                            CREATE NEW
                        </Button>
                    </Tooltip>
                </div>


            </div>


            <div className='w-full mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto' }}>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead sx={{ backgroundColor: 'teal' }}>
                            <TableRow>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '13px', padding: '3px', color: 'whitesmoke', width: '9%' }}>BILL DATE</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '13px', padding: '3px', color: 'whitesmoke', width: '9%' }}>BILL NUMBER</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '13px', padding: '3px', color: 'whitesmoke', width: '20%' }}>SUPPLIER NAME</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '13px', padding: '3px', color: 'whitesmoke', width: '7%', textAlign: 'center' }}>AMOUNT</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '13px', padding: '3px', color: 'whitesmoke', width: '7%', textAlign: 'center' }}>CGST</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '13px', padding: '3px', color: 'whitesmoke', width: '7%', textAlign: 'center' }}>SGST</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '13px', padding: '3px', color: 'whitesmoke', width: '7%', textAlign: 'center' }}>IGST</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '13px', padding: '3px', color: 'whitesmoke', width: '7%', textAlign: 'center' }}>TOTAL</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '13px', padding: '3px', color: 'whitesmoke', width: '7%', textAlign: 'center' }}>QTY</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '13px', padding: '3px', color: 'whitesmoke', width: '15%', textAlign: 'center' }}>ACTION</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody sx={{ backgroundColor: 'white' }}>
                            {filteredData.map(item => (
                                <TableRow key={item.id} className={item.IsActive ? '' : 'inactiveRow'}
                                    sx={{
                                        '&:hover': {
                                            backgroundColor: '#B2DFDB', // Change color on hover
                                        },
                                    }}
                                >
                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '25px', padding: '5px', width: '9%' }}>{formatDate(item.BillDate)}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '25px', padding: '5px', width: '9%' }}>{item.BillNumber}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '25px', padding: '5px', width: '20%' }}>{item.SupplierName}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '25px', padding: '5px', width: '7%', textAlign: 'center' }}>{item.TaxableAmount}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '25px', padding: '5px', width: '7%', textAlign: 'center' }}>{item.CGSTAmount}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '25px', padding: '5px', width: '7%', textAlign: 'center' }}>{item.SGSTAmount}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '25px', padding: '5px', width: '7%', textAlign: 'center' }}>{item.IGSTAmount}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '25px', padding: '5px', width: '7%', textAlign: 'center' }}>{item.GrandTotal}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '25px', padding: '5px', width: '7%', textAlign: 'center' }}>{item.TotalQuantity}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '25px', padding: '5px', width: '15%', textAlign: 'right' }}>

                                        <IconButton component={Link} to={`/PurchaseDetails/${item.Id}`} color="warning">
                                            <Info />
                                        </IconButton>
                                        {/* {hasEditMasterPermission && item.IsActive && (
                                            <Tooltip
                                                title="Purchase Return"
                                                componentsProps={{
                                                    tooltip: {
                                                        sx: {
                                                            backgroundColor: 'teal',
                                                            color: 'white',
                                                            border: '1px solid white',
                                                            fontWeight: 'bold',
                                                            boxShadow: 2,
                                                        },
                                                    },
                                                }}
                                            >
                                                <IconButton component={Link} to={`/PurchaseReturnCreate/${item.Id}`} color="primary">
                                                    <ApiIcon />
                                                </IconButton>
                                            </Tooltip>
                                        )} */}

                                        {hasEditMasterPermission && item.IsActive && (
                                            <IconButton component={Link} to={`/PurchaseEdit/${item.Id}`} color="primary">
                                                <EditIcon />
                                            </IconButton>
                                        )}
                                        {hasDeleteMasterPermission && item.IsActive && (
                                            <IconButton onClick={() => openConfirmDialog(item.Id)} color="error">
                                                <DeleteIcon />
                                            </IconButton>
                                        )}
                                        {!item.IsActive && (
                                            <IconButton onClick={() => handleActivate(item.Id)} color="success">
                                                <ActivateIcon />
                                            </IconButton>
                                        )}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>

            {/* Confirmation Dialog */}

            <Dialog
                open={confirmDialogOpen}
                onClose={closeConfirmDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete this record?
                    </DialogContentText>
                </DialogContent>

                <DialogActions>
                    <button
                        onClick={closeConfirmDialog}
                        style={{
                            backgroundColor: '#dc3545',
                            color: '#ffffff',
                            border: '1px solid #dc3545',
                            borderRadius: '4px',
                            padding: '8px 16px',
                            cursor: 'pointer',
                            marginRight: '8px',
                        }}
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleDelete}
                        style={{
                            backgroundColor: '#28a745',
                            color: '#ffffff',
                            border: '1px solid #28a745',
                            borderRadius: '4px',
                            padding: '8px 16px',
                            cursor: 'pointer',
                        }}
                    >
                        Confirm
                    </button>
                </DialogActions>

            </Dialog>

        </div>
    );
}

export default PurchaseIndex;



